import React, { FC, memo } from 'react'
import { useRouterPush } from '@/client/hooks'
import { refineValueFromURL } from '@/client/utils/labelLibrary'
import { CustomFiles, DesignServiceFiles, FavouriteTable, GraphicTicketFiles, OrderTable } from './TableStyle'
import { MultiTableProps } from './types'

export const MultiTable: FC<MultiTableProps> = memo(
  ({ tableType, page, searchItem, folderName, content, uploadData }) => {
    const { asPath } = useRouterPush()
    const { getCurrentTab, searchParam } = refineValueFromURL(asPath)
    if (getCurrentTab === 'myorder-files') {
      return <OrderTable content={content} />
    }
    if (getCurrentTab === 'graphic-ticket-files') {
      return <GraphicTicketFiles searchItem={searchItem} content={content} />
    }
    if (getCurrentTab === 'design-service-files') {
      return <DesignServiceFiles searchItem={searchItem} content={content} />
    }
    if (getCurrentTab === 'custom-files') {
      return <CustomFiles searchItem={searchItem} content={content} uploadData={uploadData} />
    }
    if (getCurrentTab === 'favourite-files') {
      return <FavouriteTable content={content} />
    }

    return <></>
  }
)

MultiTable.displayName = 'MultiTable'
